import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard/Dashboard';
import JobApp from './components/JobApp/JobApp';
import './index.css';

// Import icons (sesuaikan dengan lokasi icon Anda)
import DashboardIcon from './logo.svg';
// import icons lainnya...

function App() {
  const [loginStatus, setLoginStatus] = useState(true);

  const menu = [
    { id: 1, title: 'Dashboard', path: '/', icon: DashboardIcon },
    { id: 2, title: 'KTA', path: '/kta', icon: DashboardIcon },
    { id: 3, title: 'MULTIGUNA', path: '/multiguna', icon: DashboardIcon },
    { id: 4, title: 'EARN', path: '/earn', icon: DashboardIcon },
    { id: 5, title: 'Users', path: '/users', icon: DashboardIcon },
    { id: 6, title: 'Job', path: '/job', icon: DashboardIcon },
    { id: 7, title: 'Job App', path: '/job-app', icon: DashboardIcon },
    { id: 8, title: 'Mail', path: '/mail', icon: DashboardIcon },
    { id: 9, title: 'Testimoni', path: '/testimoni', icon: DashboardIcon },
    { id: 10, title: 'Document', path: '/document', icon: DashboardIcon },
  ];

  const loginHandler = (status) => {
    setLoginStatus(status);
  };

  return (
    <Router>
      <div style={{ display: 'flex' }}>
        <Sidebar 
          loginStatus={loginStatus} 
          loginHandler={loginHandler} 
          menu={menu} 
        />
        <div style={{ marginLeft: '250px', width: '100%' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/job-app" element={<JobApp />} />
            {/* Tambahkan route lainnya */}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;